// extracted by mini-css-extract-plugin
export default {"wrapper":"AFIRadarChart_wrapper__AYwJq","title":"AFIRadarChart_title__GshAQ"};